<div class="page-container">
  <!-- HEADER -->
  <header class="page-header">
    <span class="eyebrow">Corporate Profile</span>
    <h1 class="page-title">Company Details</h1>
    <p class="page-subtitle">
      Registered UAE offices and operational coordination details for Onixhu LLC.
    </p>
  </header>

  <!-- OFFICE LOCATIONS SECTION -->
  <section class="section-block">
    <h2 class="block-title">Registered Office Locations</h2>
    <div class="offices-grid">
      <div *ngFor="let office of offices" class="office-card">
        <span class="office-badge">{{ office.title }}</span>
        <h3 class="office-entity">{{ office.entity }}</h3>
        <div class="address-lines">
          <p *ngFor="let line of office.lines">{{ line }}</p>
        </div>
      </div>
    </div>
  </section>

  <!-- SUPPORT & COORDINATION -->
  <div class="content-card">
    <h2 class="card-title">Support & Coordination</h2>

    <div class="contact-list">
      <div class="contact-block">
        <span class="contact-role">Customer & Booking Desk</span>
        <span class="contact-desc">In-App Support Dashboard</span>
        <span class="contact-note">Assistance with active orders, timesheets, and site logistics</span>
      </div>

      <div class="contact-block">
        <span class="contact-role">Vendor & Fleet Operations</span>
        <span class="contact-desc">Partner Portal Verification</span>
        <span class="contact-note">Fleet onboarding, document approvals, and subscription plans</span>
      </div>

      <div class="contact-block">
        <span class="contact-role">Corporate & Legal Governance</span>
        <span class="contact-desc">Onixhu LLC Corporate Offices</span>
        <span class="contact-note">DFHQ Dubai & SHAMS Sharjah, United Arab Emirates</span>
      </div>
    </div>
  </div>

  <!-- QUICK LINKS -->
  <footer class="legal-nav-bar">
    <span>Platform Documentation:</span>
    <div class="nav-links">
      <a routerLink="/privacy">Privacy Policy</a>
      <span class="divider">·</span>
      <a routerLink="/terms">Terms & Conditions</a>
      <span class="divider">·</span>
      <a routerLink="/rental-responsibility">Rental Responsibility</a>
    </div>
  </footer>
</div>
